import { render, staticRenderFns } from "./elt-icon.vue?vue&type=template&id=2297dbf1&"
import script from "./elt-icon.vue?vue&type=script&lang=js&"
export * from "./elt-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports